import type { FetchResult } from "@apollo/client";
import type {
  GeneratePresignedDocumentPutUrlMutation,
  GeneratePresignedDocumentPutUrlMutationVariables,
} from "~/graphql/supergraphTypes";

type GeneratePresignedDocumentPutUrlMutationFn = (options: {
  variables: GeneratePresignedDocumentPutUrlMutationVariables;
}) => Promise<FetchResult<GeneratePresignedDocumentPutUrlMutation>>;

export type UploadGpSupportingDocumentInput = {
  file: File;
  clientId: number;
  generatePresignedPutUrl: GeneratePresignedDocumentPutUrlMutationFn;
};

const DEFAULT_CONTENT_TYPE = "application/octet-stream";

export const uploadGpSupportingDocument = async ({
  file,
  clientId,
  generatePresignedPutUrl,
}: UploadGpSupportingDocumentInput): Promise<string> => {
  const contentType = file.type || DEFAULT_CONTENT_TYPE;

  const presignResult = await generatePresignedPutUrl({
    variables: {
      input: {
        filename: file.name,
        contentType,
        contentLength: file.size,
        clientId,
      },
    },
  });

  const presigned = presignResult.data?.generatePresignedDocumentPutUrl;
  if (!presigned) {
    throw new Error("Failed to obtain presigned upload URL");
  }

  const putResponse = await fetch(presigned.putUrl, {
    method: "PUT",
    body: file,
    headers: { "Content-Type": contentType },
  });

  if (!putResponse.ok) {
    throw new Error(`Supporting document upload failed (${putResponse.status})`);
  }

  return presigned.s3DocumentKey;
};
